import React, { FC, memo, useEffect } from 'react';
import { getUnitServiceHistories } from 'state/ducks/unit-service-history/operations';
import { AppState } from 'state/store';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { ServiceHistoryTable } from './service-history-table';

interface Props {
	isLoading?: boolean;
	unitId?: number;
}

export const ServiceHistoryTableWrapper: FC<Props> = memo(({ isLoading, unitId }) => {
	const dispatch = useAppDispatch();

	const { unitServiceHistories } = useAppSelector((state: AppState) => state.unitServiceHistoryReducer);

	useEffect(() => {
		if (unitId) {
			getUnitServiceHistories(unitId)(dispatch);
		}
	}, [dispatch, unitId]);

	return <ServiceHistoryTable  isLoading={isLoading ?? false} data={unitServiceHistories} unitId={unitId} />;
});
